module.exports = __webpack_public_path__ + "img/fireworks3.c4d2f60c.svg";